function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 16px;\n  height: 16px;\n  color: ", ";\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  button {\n    padding: 0 10px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../../atoms/Text';
import CustomButton from '../../atoms/CustomButton';
import { defaultTheme } from '../../../utils';
var ModalHeaderContainer = styled.div(_templateObject());
var CloseButton = styled.span(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.status.cancel;
});

var ModalHeader = function ModalHeader(_ref2) {
  var title = _ref2.title,
      showCloseButton = _ref2.showCloseButton,
      showCloseIcon = _ref2.showCloseIcon,
      onCloseClick = _ref2.onCloseClick,
      rest = _objectWithoutPropertiesLoose(_ref2, ["title", "showCloseButton", "showCloseIcon", "onCloseClick"]);

  return /*#__PURE__*/React.createElement(ModalHeaderContainer, rest, /*#__PURE__*/React.createElement(Text, {
    className: "header",
    text: title,
    size: "header3",
    color: "bodyTextDark"
  }), showCloseButton && /*#__PURE__*/React.createElement(CustomButton, _extends({
    variant: "outlined",
    onClick: function onClick() {
      return onCloseClick();
    }
  }, rest), "Close"), showCloseIcon && /*#__PURE__*/React.createElement(CloseButton, _extends({
    onClick: function onClick() {
      return onCloseClick();
    }
  }, rest), "\u2715"));
};

ModalHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string.isRequired,
  showCloseButton: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
  onCloseClick: PropTypes.func
} : {};
ModalHeader.defaultProps = {
  title: '',
  showCloseButton: false,
  showCloseIcon: false,
  theme: defaultTheme
};
export default ModalHeader;